export default class CarouselObserver {
    constructor(el) {
        this.DOM = { el: el };

        this.initEvents();
    }

    initEvents = () => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                entry.target.classList[entry.isIntersecting ? 'remove' : 'add']('outside-viewport');
                entry.target.style.opacity = `${entry.intersectionRatio}`;
                entry.target.style.transform = `scale(${0.75 + entry.intersectionRatio * 0.25})`;

                if (entry.intersectionRatio <= 0.1) {
                    entry.target.style.opacity = `0`;
                    entry.target.style.transform = `scale(0.75)`;
                } else if(entry.intersectionRatio >= 0.9) {
                    entry.target.style.opacity = null;
                    entry.target.style.transform = null;
                }
            });
        }, { root: this.DOM.el, threshold: [0.01, 0.1, 0.25, 0.5, 0.75, 0.9, 0.99] });

        this.DOM.el.querySelectorAll('.carousel__slide').forEach((slide) => {
            observer.observe(slide);
        });
    }
}
